import React from 'react'
import { Switch, Route, Redirect, withRouter } from 'react-router-dom'

// pages
import PermissRoles from './list'

const RolesAssignment = props => {
  return(
    <Switch>
      <Route path={`${props.match.path}`} component={PermissRoles} exact />
      <Route path="*">
        <Redirect to={`${props.match.path}`} />
      </Route>
    </Switch>
  )
}

export default withRouter(RolesAssignment)
